import { StyleSheet, Text, View } from "react-native";
import { Colors, Typography } from "../../styles";

const ProIcon = () => {
  return (
    <View style={styles.container}>
      <Text style={styles.text}>PRO</Text>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: Colors.yellow700,
    paddingVertical: 5,
    paddingHorizontal: 10,
    borderRadius: 10,
  },
  text: {
    ...Typography.weightBold,
    color: Colors.black,
    fontSize: 10,
  },
});

export default ProIcon;
